'use strict';

import type { UserConnecture } from '../../Entities/User/UserConnecture';
import { EntityCollection } from '../EntityCollection';

export class UserConnectureCollection extends EntityCollection<UserConnecture> {}
